<template>
  <div>
    <AdminPageTitle :title="'Видео'" class="mt-10"/>
        <AppButton
              @click="videoFileDialog=true"
              class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
        >
            <span>Добавить</span>
        </AppButton>
        <v-col cols=12>
              <v-text-field
                  v-model="videoSearchValue"
                  label="Что ищем"
                  variant="outlined"
                  clearable
                  v-on:click:clear="clearSearch()"
                  rounded
              >
                <template v-slot:append>

                  <v-icon
                      icon="mdi-book-search-outline"
                      @click="filterVideos()"
                  ></v-icon>

                </template>
              </v-text-field>
        </v-col>
          <StateWrapper
          :content="data.videos"
          :loadingStatus="loadingStatus"
          :checkLogin="false"
      >
        <div class="wrapper">  
          <div class="book-shelf-page__results">
            <div class="book-shelf-page__items" v-if="data.videos">
                <AccordionItemWithEdit
                v-for="(v, idx) in data.videos"
                :key="v.id"
                :isOpen="currentId === v.id"
                @open="setCurrentId"
                :style="{ 'animation-delay': `0.${idx}s` }"
                :id="v.id"
            >
              <template v-slot:top>
                <h4 >
                    {{v.videoDescription}}
                </h4>
              </template>
              <template v-slot:bottom>
                <div class="ma-2" v-if="v.id">
                  <h4>Id:</h4>
                  <div class="book-shelf-page__chips">
                  <span>{{v.id}}</span>
                  </div>
                </div>
                <div class="ma-2" v-if="v.createDate">
                  <h4>Добавлен:</h4>
                  <div class="book-shelf-page__chips">
                  <span>{{v.createDate}}</span>
                  </div>
                </div>
                <div class="ma-2" v-if="!!v.status">
                  <h4>Статус:</h4>
                  <div class="book-shelf-page__chips">
                  <span v-if="!!v.status && v.status==='FILE_UPLOADED'">Видео загружено</span>
                  <span v-if="!!v.status && v.status==='FILE_PROCESSING'">Видео обрабатывается</span>
                  <span v-if="!!v.status && v.status==='FILE_PROCESSED'">Видео обработано</span>
                  <span v-if="!!v.status && v.status==='FILE_FAIL_PROCESSING'">Ошибка обработки видео</span>
                  </div>
                </div>
                <div class="ma-2" v-if="!!v.posterName && v.posterName.length >0">
                  <h4>Постер:</h4>
                  <div class="book-shelf-page__chips">
                    <span> 
                      <v-img width="160" :aspect-ratio="1" cover :src="`https://navigator.eurekacenter.ru/video${v.posterName}`"> </v-img>        
                    </span>
                  </div>
                </div>
                <div class="ma-2" v-if="v.workDir">
                  <h4>WD:</h4>
                  <div class="book-shelf-page__chips">
                    <span> 
                      {{ v.workDir }}        
                    </span>
                  </div>
                </div>
                <v-divider color="accent" class="mt-8"></v-divider>
                <div class="ma-2">
                    <v-row>
                       
                         <AppButton
                            v-if="v.status==='FILE_PROCESSED'"
                            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                            @click="playVideo(v)"
                            >
                            <span>Смотреть</span>
                        </AppButton>
                         <AppButton
                            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                            @click="editVideoMethod(v)">
                            <span>Редактировать</span>
                        </AppButton>
                        <AppButton
                            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                            @click="deleteVideoMethod(v)">
                            <span>Удалить</span>
                        </AppButton>
                    </v-row>
                </div>



              </template>
                </AccordionItemWithEdit>
            </div>
  
            <div class="flex flex__jc-c" v-if="!!data && data.videosCount ">
              <vue-awesome-paginate
                  :total-items="data.videosCount"
                  v-model="currentPage"
                  :items-per-page="itemsPerPage"
                  :max-pages-shown="maxPagesShown"
                  @click=updateVideos();
              />
            </div>
          </div>
        </div>
      </StateWrapper>
   
    <v-dialog v-model="videoFileDialog" scrollable>
      <v-card>
        <v-card-title class="card_ligth_header">
          <h5 v-if="!!this.id">Редактирование видео</h5>
          <h5 v-else>Добавление видео</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="videoForm">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                      label="Описание*"
                      v-model="videoDescription"
                      :rules="descriptionRules"
                      :counter="500"
                      variant="outlined"
                      hint="Укажите описание"
                      required
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-number-input
                    v-model="posterTimeInSec"
                    label="На какой секунде вырезать постер"
                    :min="0"
                    :max="59"
                    :step="1"
                  ></v-number-input>
                </v-col>
                <v-col cols="12" v-if="(!this.id)">
                  <v-file-input
                      show-size
                      v-model="videoFileBody"
                      ref="videoFileBody"
                      :rules="fileRules"
                      accept="video/mp4,video/x-m4v,video/*"
                      clearable
                      variant="outlined"
                      counter
                      rounded
                      label="Загрузить файл*"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-progress-linear
                      v-if="uploadPercentage>0 & uploadPercentage<100"
                      color="amber"
                      v-model="uploadPercentage"
                      height="25"
                  >
                    <strong>{{ Math.ceil(uploadPercentage) }}%</strong>
                  </v-progress-linear>
                </v-col>
                <v-col cols="12" v-if="uploadPercentage===100">
                </v-col>
              </v-row>
            </v-container>
            <small>*обязательно для заполнения</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card_ligth_actions">
          <v-spacer></v-spacer>
           <AppButton
            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
             @click="closeVideoFileForm">
            <span>Закрыть</span>
            </AppButton>

            <AppButton
              v-if="this.id"
              class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
              @click="editVideoDescription">
              <span>Сохранить</span>
            </AppButton>
            <AppButton
              v-else
              class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
              :disabled="downloadAnimation"
              @click="saveSingleVideoFile">
              <span>Сохранить</span>
            </AppButton>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-dialog 
    v-model="showVideo" 
    persistent 
    transition="dialog-bottom-transition"
    fullscreen
    
    >
      <v-card>
        <v-card-header>
         <h2 class="ma-10">{{ selectedVideo }}</h2>
        </v-card-header>
        <div class="ml-16  mr-16" style="max-height: 60%;">
  <Vue3VideoPlayer
            :src="videoSrc"
            :cover="posterSrc"
            :core="HLSCore"
        ></Vue3VideoPlayer>
        </div>
      
        <v-card-actions class="card_ligth_actions">
          <AppButton
          class="app-button n-admin-cource__add ma-10 w-100"
          @click="destroy(null)">
            <span>Закрыть</span>
          </AppButton>
         

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { customAxios} from "@/service/customAxios";
import HLSCore from '@cloudgeek/playcore-hls'
import {customStorage} from "@/service/customStorage";
import AppButton from "@/elements/AppButton.vue";
import AdminPageTitle from "@/elements/AdminPageTitle.vue";
import StateWrapper from "@/components/StateWrapper.vue";
import { setCurrentIdValue } from "@/utils/common";
import AccordionItemWithEdit from "@/components/AccordionItemWithEdit.vue";


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getIndex(list,id) {
  for (var i =0; i< list.length; i++) {
    if (list[i].id === id) {
      return i;
    }
  }
  return -1;
}

export default {
  name: 'AdminLibraryPage',

  props: [],
  components:{
    AppButton,
    StateWrapper,
    AdminPageTitle,
    AccordionItemWithEdit,
  },


  data: () => ({
    loadingStatus:"loading",
    currentId:'',
    data:'',
    maxPagesShown:5,
    itemsPerPage:15,
    currentPage:1,
    showVideo: false,
    videoFileDialog: false,
    selectedVideo: '',
    id:'',
    videoDescription:'',
    isExternalLink: false,
    posterTimeInSec:15,
    externalLinkUrl:'',
    videoFileBody:[],
    fileRules: [
      (v) => !!v || "Необходимо прикрепить файл!",
    ],
    descriptionRules: [
      v => (v && v.length <= 500) || 'Значение до должно превышать 500 символов!',
    ],
    uploadPercentage:0,
    downloadAnimation: false,
    videoSrc: '',
    posterSrc:'',
    videoSearchValue:'',
    videoFiles:[],
    HLSCore,
    volume: 80,
    showLoader: false,
  }),
  methods: {
    setCurrentId(value) {
      this.currentId = setCurrentIdValue(value, this.currentId);
    },

    createVideo(){
      this.id='';
      this.videoFileDialog=true
    },

    closeVideoFileForm(){
      this.videoDescription = '';
      this.isExternalLink = false;
      this.videoFileBody= [];
      this.externalLinkUrl = '';
      this.uploadPercentage = 0;
      this.videoFileDialog = false;
      this.downloadAnimation=false;
      this.posterTimeInSec = 15;
      this.getVideos();
      this.id=''
    },
    clearSearch(){
      this.videoSearchValue = null;
      this.currentPage = 1;
    },
    filterVideos() {
      this.currentPage = 1;
      this.getVideos();
    },
    updateVideos(){
      this.getVideos();
    },
    getVideos() {
        customAxios.post('library/video/paginated',{
            page: this.currentPage,
            notePerPage: this.itemsPerPage,
            reqString: this.videoSearchValue
          })
                  .then((res) => {
                    if (res.status === 200) {
                      this.data = res.data;
                      this.videoFiles = res.data.videos;
                      this.loadingStatus = "loaded";
            
                    }
                  })
                  .catch((error) => {
                
                    this.loadingStatus = "error";
                    console.log(error)
                  })

    },

    editVideoDescription(){
    if(this.id){
       let video = {
         videoDescription: capitalizeFirstLetter(this.videoDescription),
         isExternalLink: this.isExternalLink,
         externalLinkUrl: this.externalLinkUrl

       }
       customAxios.put('library/video/'+this.id, video)
          .then((res) => {
            console.log("upload result: " + res)
            if (res.status === 202) {
                this.closeVideoFileForm();
            }
          }).catch((error) => {
            this.closeVideoFileForm();
            alert("при загрузке видео возникла ошибка!");
            console.log("Error: " + error);
          });
    } else {
            alert("Не выбран файл для изменения описания!")
    }

    },


    saveSingleVideoFile() {
      this.$refs.videoForm.validate().then((result) => {
        if (result.valid) {
          let video = {
            isExternalLink: false,
            posterTimeInSec: this.posterTimeInSec,
            videoDescription: capitalizeFirstLetter(this.videoDescription),
          }
              if (this.$refs.videoFileBody.files.length>0) {
                customAxios.post('library/video', video)
                    .then((res) => {
                      console.log("upload result: " + res)
                      if (res.status === 201) {
                        this.downloadAnimation = true;
                        let formData = new FormData();
                        formData.append("file", this.$refs.videoFileBody.files[0]);
                        this.axios
                            .post("https://navigator-backend.eurekacenter.ru/api/video/upload/file/" + res.data.id, formData, {
                              headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + customStorage.get("user-token"),
                              },
                              onUploadProgress: function (progressEvent) {
                                this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                              }.bind(this)

                            }).then((res2) => {
                          console.log("upload result: " + res2)
                          if (res2.status === 201) {
                            this.closeVideoFileForm();
                          }
                        })
                            .catch((error) => {
                              this.closeVideoFileForm();
                              alert("при загрузке видео возникла ошибка!");
                              console.log("Error: " + error);
                            });
                      }
                    });
              } else {
                alert("Необходимо прикрепить файл!")
              }
}


      })


    },

    editVideoMethod(item){
      this.id = item.id
      this.isExternalLink = item.isExternalLink;
      this.externalLinkUrl= item.externalLinkUrl;
      this.videoDescription = item.videoDescription;
      this.videoFileDialog = true;
    },

    deleteVideoMethod(item){
      customAxios
          .delete(
              "library/video/" + item.id
          )
          .then((response) => {
            if (response.status === 202) {
              let index = getIndex(this.videoFiles, item.id);
              this.videoFiles.splice(index, 1);
            } else {
              alert(response.data.message);
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error)
          });
    },
    viewCore(id, player) {
      console.log(id, player);
      this.players[id] = player;
    },

    play(id) {
      console.log('custom play: id =', id);
      this.players && this.players[id] && this.players[id].play();
    },
    destroy(id) {
      this.showVideo = false;
      this.players && this.players[id] && this.players[id].destroy();
    },
   
    playVideo(item){
      this.selectedVideo = item.videoDescription
      this.videoSrc = "https://navigator.eurekacenter.ru/video" + item.sourceHlsIndex
      this.posterSrc ="https://navigator.eurekacenter.ru/video" + item.posterName
      this.showVideo = true

    },
    playInternalVideo(videoSrc, posterSrc){
      this.videoSrc = "https://navigator.eurekacenter.ru/video" + videoSrc
      this.posterSrc ="https://navigator.eurekacenter.ru/video" + posterSrc
      this.showVideo = true
    },

  },
  computed: {


    loggedIn() {
      return this.$store.state.authentication.status.loggedIn
    },
    user() {
      return this.$store.state.authentication.user
    },
    authentication() {
      return this.$store.state.authentication
    },

  },
  created: function () {
    this.getVideos();
  }
}
</script>

<style lang="scss">



.v-dialog--fullscreen .v-overlay__content {
  border-radius: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  max-width: 100% !important;
  max-height: 100%;
  overflow-y: auto;
  top: 0;
  left: 0;
}



.large-dialog.v-dialog .v-overlay__content {
  max-width: none;
  width: 100%;
}

.v-dialog--scrollable .v-overlay__content {
  justify-content: center;
}

.admin-lib {
  margin-bottom: 60px;

  &__checkboxies {
    text-align-last: left;
  }

  &__checkbox + .n-parametrs__checkbox {
    margin-top: 16px;
  }

  &__counter {
    position: absolute;
    top: 0;
    right: 0;
    background: $gradient;
    transform: translate(50%, -50%);
    border-radius: 50%;
    @include flex-center;
    min-width: 30px;
    min-height: 30px;
    padding: 4px;
    aspect-ratio: 1/1;
  }

  &__opener {
    @include button-default-small;
    display: inline-block;
    position: relative;
    padding: 8px 16px;
  }

  &__table_button {
    @include button-default-for-table;
    display: inline-block;
    position: relative;
    padding: 8px 16px;
  }


  svg {
    stroke: #fff;
  }

  &__parametrs {
    background-color: #f5f5f5;
    padding: 16px;
    margin-top: 16px;
    border-radius: 8px;
  }
}

.admin-users {
  @include page;

  &__item + .admin-clients__item {
    margin-top: 16px;
  }

  &__info {
    font-size: 18px;
    line-height: 30px;

    span {
      color: $accent-1;
    }

    svg {
      margin-right: 8px;
      stroke: $accent-1;
    }
  }

  &__name {
    display: flex;
    justify-content: space-between;
  }
}
</style>
